/* eslint-disable css-modules/no-unused-class */
import { FC } from 'react';
import { Button } from 'common-components';
import { useTranslationContext } from '../contexts/translationContext';
import styles from './notFound.module.scss';

const NotFound: FC<{ onGoHome: Function }> = ({ onGoHome }: { onGoHome: Function }) => {
    const { translate } = useTranslationContext();
    return (
        <div
            className={styles['not-found']}
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/notFound.svg)` }}
        >
            <div className={styles.content}>
                <div className={styles.title}>{translate('ThisOneIs')}</div>
                <div className={styles['sub-title']}>404</div>
                <div className={styles.text}>{translate('WeAllKnowTheseMoments')}</div>
                <Button type="flatGrayOpacity" onClick={onGoHome} text={translate('PhoneHome')} lowerCase />
            </div>
            <div
                className={styles.bottom}
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/notFoundBottom.svg)` }}
            ></div>
            <div
                className={styles['right-lights']}
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/notFoundLight.svg)` }}
            ></div>
        </div>
    );
};

export default NotFound;
